import { apiSlice } from "../../../app/api/apiSlice";

export const importTpoStatusByIdApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		importTpoStatusById: builder.mutation({
			query: (credentials) => ({
				url: `/api/v1/org_tpo/get_latest_status/${credentials?.dag_run_id}/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useImportTpoStatusByIdMutation } = importTpoStatusByIdApiSlice;
